import React from 'react'

import { ZariContext } from '_zari/context'
import queryString from 'query-string'

import { Portlet } from '_zari/core'

import { CodigosTransaccionesConstant, TiposTablaComunConstant } from 'constants/index'

import { IdGen } from 'utils'

import * as AsientoContableCrud from 'services/asientosContables.service'
import * as TablasComunesService from 'services/tablasComunes.service'

import MainForm from './mainForm'

const NuevoxPlantillaPage = ({ match, location }) => {
  const __zariContext = React.useContext(ZariContext)

  const [_mainFormKey, setMainFormKey] = React.useState(null)
  const [editData, setEditData] = React.useState({})
  const [isLargeDataset, setIsLargeDataset] = React.useState(false)

  const portletBreadcrumbs = React.useMemo(() => {
    let { origen } = queryString.parse(location.search)
    let nombreOrigen = 'DIARIO'
    TablasComunesService.obtenerxTipoAsSlim(TiposTablaComunConstant.ORIGENES)
      .then(({ data }) => {
        const origenEncontrado = data.find(x => x.codigo === origen)
        if (origenEncontrado) {
          nombreOrigen = origenEncontrado.nombre.toUpperCase()
        }
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
      .finally(() => {
        return [
          {
            name: 'Asientos Contables',
            path: `/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}`
          },
          { name: `Origen ${nombreOrigen}` }
        ]
      })
  }, [location.search, __zariContext])

  React.useEffect(() => {
    if (match.params.id) {
      AsientoContableCrud.getResumenEdicion(match.params.id)
        .then(({ data }) => {
          const totalRegistros = data.resumen.totalRegistros

          if (totalRegistros > 500) {
            setEditData({
              ...data.cabecera,
              _id: match.params.id,
              resumen: data.resumen,
              cuentasContables: data.cuentasContables,
              detalles: []
            })
            setIsLargeDataset(true)
            setMainFormKey(IdGen.newId())
          } else {
            AsientoContableCrud.getAsEdicion2(match.params.id)
              .then(({ data }) => {
                setEditData(data)
                setIsLargeDataset(false)
                setMainFormKey(IdGen.newId())
              })
              .catch(({ data: { error } }) => {
                __zariContext.snack('error', error)
              })
          }
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
    } else {
      setMainFormKey(IdGen.newId())
    }
  }, [match.params.id, __zariContext])

  const resetMainForm = React.useCallback(() => {
    if (match.params.id) {
      AsientoContableCrud.getResumenEdicion(match.params.id)
        .then(({ data }) => {
          const totalRegistros = data.resumen.totalRegistros

          if (totalRegistros > 500) {
            setEditData({
              ...data.cabecera,
              _id: match.params.id,
              resumen: data.resumen,
              cuentasContables: data.cuentasContables,
              detalles: []
            })
            setIsLargeDataset(true)
          } else {
            AsientoContableCrud.getAsEdicion2(match.params.id)
              .then(({ data }) => {
                setEditData(data)
                setIsLargeDataset(false)
              })
              .catch(({ data: { error } }) => {
                __zariContext.snack('error', error)
              })
          }
          setMainFormKey(IdGen.newId())
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
    } else {
      setEditData({})
      setIsLargeDataset(false)
      setMainFormKey(IdGen.newId())
    }
  }, [match.params.id, __zariContext])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Asientos Contables' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          {_mainFormKey && (
            <MainForm
              key={_mainFormKey}
              editData={editData}
              resetMainForm={resetMainForm}
              isLargeDataset={isLargeDataset}
              asientoId={match.params.id}
            />
          )}
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default React.memo(NuevoxPlantillaPage)
